module.exports = __webpack_public_path__ + "img/duanwu_ps_17.39c594f3.jpg";